import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LangsService } from './core/services/langs.service';
import { ThemeService } from './core/services/theme.service';
import { LoadingService } from './core/services/loading.service';
import { ToastModule } from 'primeng/toast';
import { ProgressBarModule } from 'primeng/progressbar';
import { MessageService } from 'primeng/api';
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastModule, ProgressBarModule],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  langService = inject(LangsService);
  themeService = inject(ThemeService);
  loadingService = inject(LoadingService);
  protected readonly title = signal('dawmt-support-system');
  private messageService = inject(MessageService);
  toastBreakpoints: any = {
    '650px': {
      width: '95%',
      right: '2.5%',
      left: '2.5%',
    }
  };
}
